export default {"src":"/_next/static/image/public/images/no_slot_found.eb3d047ca033afe591b5b63df138db04.svg","height":126,"width":129};